import { paramsToQueryKey } from '@/shared/lib/react-query';

import type { BrandParams } from './brands.api';

const PREFIX = 'brands' as const;

export const BrandQueryKeys = {
  root: [PREFIX],

  brands: (params?: BrandParams) => paramsToQueryKey([PREFIX, 'list'], params),
};
